import { graphql } from '../graphql/generated';

// what a Nachforderung starts from; an AIS link reads the status from it too
export const REQUEST_FOR_REORDER_QUERY = graphql(`
  query ReorderStart($id: ID!) {
    request(id: $id) {
      id
      status
      reorderable
      comment
      doctor {
        id
      }
      patientData {
        birthday
        city
        country
        email
        externalId
        firstName
        lastName
        gender
        zip
        svnr
        title
        street
        phone
        insuranceCode
        idCardAuthority
        idCardNumber
        idCardType
        insuranceCategory
        insuredPerson {
          phone
          street
          title
          svnr
          zip
          birthday
          gender
          firstName
          email
          country
          city
          lastName
        }
      }
    }
  }
`);
